import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["fas fa-sync fa-lg refresh", _ctx.refreshClicked || _ctx.parentRefreshing ? 'loading' : ''])
    }, null, 2)
  ]))
}